module.exports = __webpack_public_path__ + "static/img/img_6.bf9e2856.jpg";